<ion-content class="bg-color ion-content">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <a routerLink="{{ itemList.url }}">
            {{ itemList.label }}
          </a>
        </li>
      </ul>
    </div>
    <div class="content-grid">
      <mat-card>
        <mat-card-title class="mc-title">
          <span class="table-header">Database Environment</span>
        </mat-card-title>
        <mat-card-content class="mc-content">
          <div class="table-container">
            <div class="filter-container">
              <div class="button-container">
                <button mat-raised-button class="add-button" routerLink='/baseapp/database-env/add'> Add </button>
                <div *ngIf="bubbleshow" class="box"
                  style="position:relative; margin-left: 92px;margin-top: -60px;z-index: 2;">
                  <span class="cancel-help-popup" (click)="closebubblecross()">&times;</span>
                  <p>Click "Add" button to create a Database environment</p>
                  <button mat-raised-button style="float: right;" (click)="closebubble()">Got It</button>
                </div>
              </div>
              <div class="search-container">
                <!-- <mat-form-field appearance="fill" class="non-fill">
                  <mat-label>Search</mat-label>
                  <input matInput type="text" placeholder="Search by category name" [(ngModel)]="search"
                    (ngModelChange)="getSearchOnChange($event)">
                  <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field> -->
              </div>
            </div>
            <table mat-table matTableResponsive [dataSource]="databaseEnvSource" style="table-layout: fixed;">
              <!-- Position Column -->
              <!-- <ng-container matColumnDef="position">
                  <th mat-header-cell *matHeaderCellDef> No. </th>
                  <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                </ng-container> -->
                <ng-container matColumnDef="storage_name">
                  <th mat-header-cell *matHeaderCellDef> Storage Name </th>
                  <td mat-cell *matCellDef="let element">{{element.storage_name}} </td>
                </ng-container>
                <ng-container matColumnDef="dbversion">
                  <th mat-header-cell *matHeaderCellDef> DB Version </th>
                  <td mat-cell *matCellDef="let element">{{element.dbversion}} </td>
                </ng-container>
                
              <ng-container matColumnDef="jdbc_driver">
                <th mat-header-cell *matHeaderCellDef> Jdbc Driver </th>
                <td mat-cell *matCellDef="let element">{{element.jdbc_driver}} </td>
              </ng-container>
              <ng-container matColumnDef="jdbc_string">
                <th mat-header-cell *matHeaderCellDef> Jdbc String </th>
                <td mat-cell *matCellDef="let element">{{element.jdbc_string}} </td>
              </ng-container>
              <ng-container matColumnDef="jar_file_name">
                <th mat-header-cell *matHeaderCellDef> Jar File Name </th>
                <td mat-cell *matCellDef="let element">{{element.jar_file_name}} </td>
              </ng-container>
              <!-- <ng-container matColumnDef="jar_file_name_api">
                    <th mat-header-cell *matHeaderCellDef> Jar File Name API</th>
                    <td mat-cell *matCellDef="let element">{{element.jar_file_name_api}} </td>
                </ng-container> -->
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon class="icon edit" matTooltip="Edit" matTooltipPosition="above"
                    (click)="editDatabase(element.id)"> edit </mat-icon>
                  <mat-icon class="icon info" matTooltip="View More" matTooltipPosition="above"
                    (click)="viewDatabaseDetails(element.id)"> info </mat-icon>
                  <mat-icon class="icon delete" matTooltip="Delete" matTooltipPosition="above"
                    (click)="confirmDelete(element.id)"> delete </mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="dbEnvDisplayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: dbEnvDisplayedColumns;"></tr>
            </table>

            <!-- <table *ngIf="!loading">
                <tr *ngIf="!databaseEnvSource.length">
                  <td style="text-align: center;" [attr.colspan]="dbEnvDisplayedColumns.length">
                    No Records Found
                  </td>
                </tr>
              </table> -->
          </div>
        </mat-card-content>
        <!-- <div *ngIf="total_records > 5" class="load-more-bx">
            <button mat-raised-button class="load-more" (click)="loadMore()">Load More</button>
          </div> -->
        <!-- <ion-infinite-scroll *ngIf="total_records > 10" threshold="150px" (ionInfinite)="loadMore($event)">
            <ion-infinite-scroll-content loadingSpinner="dots">
            </ion-infinite-scroll-content>
          </ion-infinite-scroll> -->
      </mat-card>
      <!-- <app-about-page *ngIf="hide1200"></app-about-page> -->
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>